<soft-ds-card class="h-full min-h-[40vh] max-h-[50vh]">
  <soft-ds-card-header>
    <soft-ds-card-leading variant="tinted">
      <soft-ds-icon name="fa-regular fa-chart-mixed-up-circle-dollar" />
    </soft-ds-card-leading>
    <soft-ds-card-title>{{ '#UMSATZSTATISTIK.TITLE' | translate }}</soft-ds-card-title>
    <soft-ds-card-description>
      Zeitraum: {{ startDate() | format: 'DATE.DEFAULT' }} bis
      {{ endDate() | format: 'DATE.DEFAULT' }}
    </soft-ds-card-description>
  </soft-ds-card-header>

  <soft-ds-card-body>
    @if (error(); as error) {
      <soft-ds-empty-state
        class="min-h-[28vh]"
        variant="error"
        size="sm"
        [icon]="error.icon ?? null"
        [title]="error.subject ? (error.subject | translate) : null"
        [description]="(error.message | translate | interpolate: error.data) ?? null"
        data-testid="umsatzstatistik-widget-error"
      />
    } @else if (noData$ | async) {
      <soft-ds-empty-state
        class="min-h-[28vh]"
        size="sm"
        icon="fa-regular fa-chart-column"
        title="Keine Daten im Zeitraum gefunden"
        data-testid="umsatzstatistik-widget-empty"
      />
    } @else {
      @defer {
        <soft-main-chart
          [chartClass]="'min-h-[28vh] max-h-[28vh]'"
          [data]="chartData()"
          [loading]="loading()"
        >
        </soft-main-chart>
      } @placeholder {
        <div class="min-h-[28vh] max-h-[28vh]"></div>
      }
    }
  </soft-ds-card-body>
</soft-ds-card>
